module.exports = __webpack_public_path__ + "img/mb-settings.7ca2afc0.svg";